<monaco-editor v-model="model" :read-only="readOnly"></monaco-editor>